import * as React from "react";
const SvgGreenDots = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <circle cx={7} cy={7} r={7} fill="#05CD99" />
  </svg>
);
export default SvgGreenDots;